export default __webpack_public_path__ + "static/media/it-infrastructure-services.d97b8044.png";